const MEASUREMENT_ID = String(import.meta.env.VITE_GA_MEASUREMENT_ID ?? "");

declare global {
  interface Window {
    gtag: Gtag;
    dataLayer: unknown[];
  }
}

type Gtag = (command: string, ...args: unknown[]) => void;

export function initAnalytics() {
  if (MEASUREMENT_ID === "" || !import.meta.env.PROD) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer ??= [];
  const dataLayer = window.dataLayer;
  window.gtag = function gtag(...args: unknown[]) {
    dataLayer.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID);
}

function sendEvent(name: string, params?: Record<string, string | number | boolean>) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", name, params);
  }
}

export function trackHabitCreated(fromTemplate: boolean) {
  sendEvent("habit_created", { from_template: fromTemplate });
}

export function trackHabitCompleted() {
  sendEvent("habit_completed");
}

export function trackHabitSkipped() {
  sendEvent("habit_skipped");
}

export function trackHabitIncremented() {
  sendEvent("habit_incremented");
}

export function trackStatsViewed(scope: "global" | "habit") {
  sendEvent("stats_viewed", { scope });
}
